var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useControlled, FormGroup, unstable_useId as useId } from '@mui/material';
import CheckboxGroupContext from './CheckboxGroupContext';
var CheckboxGroup = React.forwardRef(function (props, ref) {
    var valueProp = props.value, defaultValue = props.defaultValue, nameProp = props.name, onChange = props.onChange, children = props.children, FormGroupProps = __rest(props, ["value", "defaultValue", "name", "onChange", "children"]);
    var _a = useControlled({
        controlled: valueProp,
        default: defaultValue,
        name: 'CheckboxGroup',
    }), value = _a[0], setValueState = _a[1];
    var handleChange = function (event) {
        var _a;
        var checked = event === null || event === void 0 ? void 0 : event.target.checked;
        var newValue = value;
        if (checked) {
            newValue = value.concat((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
        }
        else {
            newValue = value === null || value === void 0 ? void 0 : value.filter(function (v) { var _a; return v !== ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value); });
        }
        setValueState(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(event, newValue);
    };
    var name = useId(nameProp);
    return (React.createElement(CheckboxGroupContext.Provider, { value: { name: name, value: value, onChange: handleChange } },
        React.createElement(FormGroup, __assign({ role: "checkboxgroup", ref: ref }, FormGroupProps), children)));
});
CheckboxGroup.defaultProps = {
    defaultValue: [],
    row: true,
};
export default CheckboxGroup;
